import { ControlModes, ISections } from '@src/types/Stacks';

export const getModeStatusClass = (
  modeStatus: string | number | null | undefined,
) => {
  switch (modeStatus) {
    case 0:
      return '#20c191';
    case 1:
      return '#fc4349';
    default:
      return 'rgb(172, 172, 0)';
  }
};

export const getQuickConfigFields = (controlMode: ControlModes) => {
  const quickConfigFields: ISections['fields'] = [];

  if (controlMode.sections) {
    controlMode.sections.forEach((setting) => {
      if (setting.fields) {
        const filteredFields = setting.fields.filter(
          (field) => field.quickConfig === true,
        );
        quickConfigFields.push(...filteredFields);
      }
    });
  }

  return quickConfigFields;
};

export const getEventDuration = (start: Date | null, end: Date | null) => {
  if (!start || !end) {
    return { hours: 0, minutes: 0 };
  }
  const startDate = new Date(start);
  const endDate = new Date(end);

  const duration = Math.abs(endDate.getTime() - startDate.getTime());
  const hours = Math.floor(
    (duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
  );
  const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));

  return { hours, minutes };
};
export const getEventDurationString = (
  start: Date | null,
  end: Date | null,
) => {
  const { hours, minutes } = getEventDuration(start, end);
  return `${hours}h ${minutes}m`;
};
export const getEventDurationText = (start: Date | null, end: Date | null) => {
  const { hours, minutes } = getEventDuration(start, end);
  return `${hours > 0 ? `${hours}h ` : ''}${minutes > 0 ? `${minutes}m` : ''}`;
};
